// @flow
import WebComponent   from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  TARGET: '[data-fragment="FilterHandler.target"]',
  ITEMS: '[data-fragment="FilterHandler.item"]',
};

export default class FilterHandler extends WebComponent {
  didMount() {
    this.targetElement  = this.element.querySelector(fragments.TARGET);
    this.items = this.element.querySelectorAll(fragments.ITEMS);

    if (this.items) {
      let filled = 0;
      let checked = false;
      let inputs;
      this.items.forEach((item) => {
        inputs = item.querySelectorAll('input');
        checked = false;
        inputs.forEach((input) => {
          if (input.checked) {
            checked = true;
          }
        });
        if (checked) {
          filled = filled + 1;
        }
      });

      if (this.targetElement) {
        if (filled == 0) {
          this.targetElement.innerHTML = '';
        } else {
          this.targetElement.innerHTML = `(${filled})`;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FilterHandler.js